import React from 'react';

import PrivateLayout from "layouts/private";
import { fetchAccountsAll } from "apiRequest/account";
import createCapitalValidation from 'formValidations/createCapital';
import FormContainer from 'components/FormContainer';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { defaultError } from 'utils/message';
import toast from 'react-hot-toast';
import useToken from 'hooks/useToken';
import { fetchFiguresAll } from 'apiRequest/figure';
import { createCapital } from 'apiRequest/capitals';
import CapitalForm from 'components/forms/CapitalForm';

export default function CapitalCreate() {
  const navigate = useNavigate();

  const { token } = useToken();

  const {
    isError: isErrorAccounts,
    data: accounts,
    error: errorAccounts
  } = useQuery(
    ["account-fetchAccountsAll"],
    () => {
      return fetchAccountsAll({ token });
    });

    if (isErrorAccounts) {
      toast.error(errorAccounts.message || defaultError);
      toast.error('contact admin');
      console.error(errorAccounts);
    }

  const accountOptions = React.useMemo(() => (
    accounts?.data.data.map(({id, name, currency})=>({ value: id, label: `${id} | ${name} (${currency})`}))
  ), [accounts]);

  const {
    isError: isErrorFigure,
    data: figures,
    error: errorFigures
  } = useQuery(
    ["figure-fetchFiguresAll"],
    () => {
      return fetchFiguresAll({ token });
    });

    if (isErrorFigure) {
      toast.error(errorFigures.message || defaultError);
      toast.error('contact admin');
      console.error(errorFigures);
    }

  const figureOptions = React.useMemo(() => (
    figures?.data.data.map(({id, currency, worth})=>({ value: id, label: `${id} | ${currency}${worth}`}))
  ), [figures]);


  const mutation = useMutation(data => {
    return createCapital({ token, data });
  });

  const handleOnSubmit = async ({ values: data }) => {
    const submitData = {
      ...data
    };

    mutation.mutate(submitData, {
      onSuccess: () => {
        navigate('/capitals', { replace: true });
      },
      onError: (error) => {
        if (error.response?.status !== 422) {
          toast.error(error.message || defaultError);
          console.error(error);
        }
      }
    });
  };

  return (
    <PrivateLayout>
      <FormContainer
        title="Capital"
        subheader="Add New"
        onSubmit={handleOnSubmit}
        validationSchema={createCapitalValidation}
        serverError={mutation.error}
      >
        <CapitalForm
          loading={mutation.isLoading}
          accountOptions={accountOptions}
          figureOptions={figureOptions}
         />
      </FormContainer>
    </PrivateLayout>
  );
};
